import { useCallback } from 'react';

import { client } from '@/core/graphql/ApolloClient/apolloClient';
import { useAuthStore } from '@/core/store/auth/authStore';

export const useClearClientAuthData = () => {
	const resetAuthStore = useAuthStore(state => state.resetStore);
	const clearClientAuthData = useCallback(() => {
		resetAuthStore();
		client.clearStore();
	}, [resetAuthStore]);

	return { clearClientAuthData };
};
